import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reference-prices pa-2" },
    [
      _c("h3", { staticClass: "section-title" }, [
        _vm._v(_vm._s(_vm.$t(`pricing.referencePrices.header`))),
      ]),
      _vm._v(" "),
      _c(
        VSimpleTable,
        {
          staticClass: "reference-table",
          attrs: { dense: "", "aria-label": "Reference prices" },
        },
        [
          _c("thead", [
            _c("tr", [
              _c(
                "th",
                { staticClass: "group-header", attrs: { colspan: "2" } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(`pricing.referencePrices.strategicEngine`)
                      ) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "group-header separator-left",
                  attrs: { colspan: "2" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(`pricing.referencePrices.crossElasticityEngine`)
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { staticClass: "sub-header" }, [
                _vm._v(_vm._s(_vm.$t(`pricing.referencePrices.price`))),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "sub-header" }, [
                _vm._v(_vm._s(_vm.$t(`pricing.referencePrices.volume`))),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "sub-header separator-left" }, [
                _vm._v(_vm._s(_vm.$t(`pricing.referencePrices.price`))),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "sub-header" }, [
                _vm._v(_vm._s(_vm.$t(`pricing.referencePrices.volume`))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("td", [_vm._v(_vm._s(_vm.data.strategic.price))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.data.strategic.volume))]),
              _vm._v(" "),
              _c("td", { staticClass: "separator-left" }, [
                _vm._v(_vm._s(_vm.data.crossElasticity.price)),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.data.crossElasticity.volume))]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }